const THOUSAND = 1_000;
const MILLION = 1_000_000;

/** Round to at most one decimal and drop a trailing `.0`. */
function trimOneDecimal(value: number): string {
  return String(Math.round(value * 10) / 10);
}

/**
 * Compact number display for the topic-detail drawer: values above 999 are
 * abbreviated with `k`, and values in the millions with `m` (e.g. 1500 → "1.5k",
 * 2_000_000 → "2m"). Values ≤ 999 render unchanged.
 */
export function formatCompactNumber(value: number): string {
  if (!Number.isFinite(value)) return "—";
  const abs = Math.abs(value);
  if (abs >= MILLION) return `${trimOneDecimal(value / MILLION)}m`;
  if (abs >= THOUSAND) return `${trimOneDecimal(value / THOUSAND)}k`;
  return trimOneDecimal(value);
}
